import { usePortal as usePortalHook } from 'ui/hooks';

import type { PortalProps } from './Portal.d';

export const usePortal = ({ htmlElementID = 'portal' }: Pick<PortalProps, 'htmlElementID'>) => {
  const { closePortal, isOpen, openPortal, Portal } = usePortalHook({
    bindTo: document && document.getElementById(htmlElementID)!,
  });

  return { closePortal, isOpen, openPortal, Portal };
};
